import { defineMessages } from 'react-intl-next';

export default defineMessages({
	dashboardPageTitle: {
		id: 'dev-agents.boysenberry.dashboard.page-title',
		defaultMessage: 'Dashboard',
		description: 'Test rendered in the document page title.',
	},
	dashboardWelcome: {
		id: 'dev-agents.boysenberry.dashboard.welcome',
		defaultMessage: 'What would you like to do today?',
		description: 'Test rendered in the document page title.',
	},
});
